import React from "react";
import { View } from "react-native";
import { ThemeConsumer } from "@rneui/themed";
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";

//common component
import CommonHeader from "../../shared/commonComponents/commonHeader";
import CustomerList from "./customerList";

const CustomerScreen = () => {
    const TopTab = createMaterialTopTabNavigator()

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <View style={{ flex: 1 }} >
                    <CommonHeader headerName="Customer List" />
                    <TopTab.Navigator
                        initialRouteName="Active Customer"
                        screenOptions={{
                            tabBarLabelStyle: { fontSize: theme.largerFontSize, fontFamily: theme.bold, textTransform: 'capitalize' },
                            tabBarIndicatorStyle: { backgroundColor: theme.primary },
                            tabBarActiveTintColor: theme.primary,
                            tabBarInactiveTintColor: theme.lightFontColor,
                            tabBarAndroidRipple: { borderless: false },
                        }}
                        backBehavior="none"
                    >
                        <TopTab.Screen
                            name="Active Customer"
                            options={{ tabBarLabel: 'Active Customer', title: 'Active Customer' }}
                            component={CustomerList}
                        />
                        <TopTab.Screen
                            name="InActive Customer"
                            options={{ tabBarLabel: 'InActive Customer', title: 'InActive Customer' }}
                            component={CustomerList}
                        />
                    </TopTab.Navigator>

                </View >
            )}
        </ThemeConsumer>


    )
}

export default CustomerScreen

